import {
  CREATE_PROFILE,
  User,
  SYNC_USER,
  USER_LOGOUT,
  GET_USER,
  UPDATE_PROFILE,
  EDIT_PROFILE,
  LocationState,
  SET_CURRENT_LOCATION,
  SET_FILTER_DATA,
  FilterData,
  GET_USER_RATING,
  SET_USER_RATING,
  Ratings,
  SET_USER_PROVIDER,
} from './types';
import { SET_USER } from '../user/types';

export const getUser = (id: string) => ({
  type: GET_USER,
  id,
});

export const setUser = (user: User) => ({
  type: SET_USER,
  user,
});

export const createProfile = (details: object) => ({
  type: CREATE_PROFILE,
  details,
});

export const editProfile = (details: object) => ({
  type: EDIT_PROFILE,
  details,
});

export const syncUser = () => ({
  type: SYNC_USER,
});

export const logoutuser = () => ({
  type: USER_LOGOUT,
});

export const updateProfile = (details: object) => ({
  type: UPDATE_PROFILE,
  details,
});

export const setCurrentLocation = (location: LocationState) => ({
  type: SET_CURRENT_LOCATION,
  currentLocation: location,
});

export const setFilterData = (dataFilter: FilterData) => ({
  type: SET_FILTER_DATA,
  dataFilter,
});

export const setUserRating = (ratings: Ratings[]) => ({
  type: SET_USER_RATING,
  ratings,
});

export const getUserRating = () => ({
  type: GET_USER_RATING,
});

export const setUserProvider = (providername: string) => ({
  type: SET_USER_PROVIDER,
  providername,
});
